import { render } from "./NewsList.vue?vue&type=template&id=6d15fcc2&scoped=true"
import script from "./NewsList.vue?vue&type=script&lang=js"
export * from "./NewsList.vue?vue&type=script&lang=js"

import "./NewsList.vue?vue&type=style&index=0&id=6d15fcc2&lang=scss&scoped=true"

import exportComponent from "/opt/homebrew/var/www/zsplus_channel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d15fcc2"]])

export default __exports__